import comp from "./CurriculumProgramList";
export default comp;
